import { GroupBase, MultiValueRemoveProps } from 'react-select';
import { CloseCircleSharp } from 'react-ionicons';

export const CustomMultiValueRemove = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({
  innerProps,
}: MultiValueRemoveProps<Option, IsMulti, Group>) => {
  return (
    <div {...innerProps}>
      <span className="text-content-base-subdued">
        <CloseCircleSharp width="16px" height="16px" color="currentColor" />
      </span>
    </div>
  );
};
